import React from 'react';

import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import CustomRedirect from 'components/shared/CustomRedirect';
import { SETTINGS_ACCOUNT_PATH } from 'constants/routes';
import { useAccountPath } from 'hooks/useAccountPath';
import { isAccountFulfilledSelector } from 'store/user/selectors';

function AccountFulfilledRoute({ children, ...rest }) {
  const isAccountFulfilled = useSelector(isAccountFulfilledSelector);
  const getPath = useAccountPath();

  return (
    <Route
      {...rest}
      render={() => {
        return isAccountFulfilled ? children : <CustomRedirect to={getPath(SETTINGS_ACCOUNT_PATH)} />;
      }}
    />
  );
}

export default AccountFulfilledRoute;
